<template>
  
  <div id='app'>
    <Topbar />
    <AppMain />
    <Playbar /> 
  </div>
</template>

<script>
import Topbar from '@/components/Topbar/Topbar'
import Playbar from '@/components/Playbar/Playbar'
import AppMain from '@/components/AppMain'

export default {
  name: 'App',
  components: {
    AppMain,
    Topbar,
    Playbar,
  },
}
</script>

<style >
body{
  margin: 0 !important;
}
*{
  font-family: 'Noto Serif SC', '思源宋体', serif;
}
#app {
  background-color: #f5f5f5;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

</style>

